export default class GiftCard {
  constructor(section) {
    this.el = section.el;
    this.qrCodeAttr = 'data-qr-code';
    this.qrCode = '[data-qr-code]';

    this.addQrCode();
  }

  addQrCode() {
    const qrWrapper = this.el.querySelector(this.qrCode);

    new QRCode(qrWrapper, {
      text: qrWrapper.getAttribute(this.qrCodeAttr),
      width: 120,
      height: 120,
    });
  }
}
